import {
  getFirstParamValueAsSet,
  paramValuesMapToSearch,
  removeParamValue,
  searchToParamValuesMap,
  setParamValues,
  UrlSearch,
  UrlSearchProvider,
} from '@tableau/data-catalog-shared';
import { KeySet } from '@tableau/data-structures';
import { CatalogUrlParamKeys } from '@tableau/shared-urls/lib/src/SiteUrls';
import * as React from 'react';
import { defaultMemoize } from 'reselect';

export function constructNewSearchForColumnSelection(search: string, columnId: string): string {
  const paramValuesMap = searchToParamValuesMap(search);
  const columns = paramValuesMap[CatalogUrlParamKeys.column];
  if (columns && columns.indexOf(columnId) >= 0) {
    removeParamValue(paramValuesMap, CatalogUrlParamKeys.column, columnId);
  } else {
    setParamValues(paramValuesMap, CatalogUrlParamKeys.column, [columnId]);
  }
  return paramValuesMapToSearch(paramValuesMap);
}

export function constructNewSearchWithClearedColumnSelection(search: string): string {
  const paramValuesMap = searchToParamValuesMap(search);
  const columns = paramValuesMap[CatalogUrlParamKeys.column];
  if (columns) {
    setParamValues(paramValuesMap, CatalogUrlParamKeys.column, []);
  }
  return paramValuesMapToSearch(paramValuesMap);
}

export type TableSubplaceParams = {
  readonly urlSearchValue: string;
  readonly selectedColumns: KeySet;
  readonly updateColumnSelection: (columnId: string) => void;
  readonly clearColumnSelection: () => void;
};

export type TableSubplaceParamsProviderProps = {
  readonly children: (params: TableSubplaceParams) => React.ReactNode;
};

export class TableSubplaceParamsProvider extends React.Component<TableSubplaceParamsProviderProps> {

  public render() {
    return (
      <UrlSearchProvider>
        {urlSearch =>
          <TableSubplaceParamsProviderInternal urlSearch={urlSearch}>
            {this.props.children}
          </TableSubplaceParamsProviderInternal>
        }
      </UrlSearchProvider>
    );
  }
}

type TableSubplaceParamsProviderInternalProps = {
  readonly urlSearch: UrlSearch;
  readonly children: (params: TableSubplaceParams) => React.ReactNode;
};

class TableSubplaceParamsProviderInternal extends React.Component<TableSubplaceParamsProviderInternalProps> {

  // tslint:disable-next-line: typedef
  private readonly memoizedGetFirstParamValueAsSet = defaultMemoize(getFirstParamValueAsSet);

  public render() {
    return this.props.children({
      urlSearchValue: this.props.urlSearch.value,
      selectedColumns: this.memoizedGetFirstParamValueAsSet(this.props.urlSearch.value, CatalogUrlParamKeys.column),
      updateColumnSelection: this.updateColumnSelection,
      clearColumnSelection: this.clearColumnSelection,
    });
  }

  private readonly clearColumnSelection = () => {
    const urlSearch = this.props.urlSearch;
    const newSearchWithClearedColumnSelection = constructNewSearchWithClearedColumnSelection(urlSearch.value);
    urlSearch.update(newSearchWithClearedColumnSelection);
  }

  private readonly updateColumnSelection = (columnId: string) => {
    const urlSearch = this.props.urlSearch;
    const newSearch = constructNewSearchForColumnSelection(urlSearch.value, columnId);
    urlSearch.update(newSearch);
  }

}
